(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hb-editable-typography"] && !Shopify.designMode) return;
  try {
    // Reveal the selected editable block, including blocks inside a closed panel or carousel.
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:block:select', function(event) {
    var section = event.target.closest('.shopify-section');
    if (!section || !section.querySelector('[data-hb-section]')) return;
    var cards = Array.from(section.querySelectorAll('[data-shopify-editor-block]')).filter(function(card) {
      try { return JSON.parse(card.getAttribute('data-shopify-editor-block')).id === event.detail.blockId; }
      catch (error) { return false; }
    });
    cards.forEach(function(card) {
      var panel = card.closest('[data-review-panel]');
      if (panel) {
        var tabs = section.querySelectorAll('[data-review-tab]');
        Array.from(tabs).forEach(function(tab) {
          if (tab.dataset.reviewTab === panel.dataset.reviewPanel) tab.click();
        });
      }
    });
    requestAnimationFrame(function() {
      cards.filter(function(card) { return card.getBoundingClientRect().width > 0; }).forEach(function(card) {
        if (card.tagName === 'DETAILS') card.open = true;
        var track = card.closest('.hf-native');
        if (track && track.scrollWidth > track.clientWidth) {
          var box = track.getBoundingClientRect();
          track.scrollTo({left: track.scrollLeft + card.getBoundingClientRect().left - box.left, behavior: 'auto'});
        }
        if (card.matches('.mv-ben__item, .mv-rit__tab')) card.click();
      });
    });
  });
}
  } catch(e) { console.error(e); }
})();

})();
